import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageContainer } from '@/components/layout/PageContainer'
import { Button } from '@/components/ui/button'
import { StorefrontSettingsGuard } from './StorefrontSettingsGuard'
import { ShippingSettings } from './ShippingSettings'
import { ChargeableShippingSettings } from './ChargeableShippingSettings'
import { ReviewSettings } from '@/features/reviews/components/ReviewSettings'

export function ShippingReviewsPage() {
  const navigate = useNavigate()

  return (
    <StorefrontSettingsGuard>
      <PageContainer>
        <div className="p-6 space-y-6">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full"
              onClick={() => navigate('/storefront/settings')}
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div>
              <h2 className="text-2xl font-semibold">Shipping & Reviews</h2>
              <p className="text-sm text-muted-foreground">
                Shipping configuration and customer reviews
              </p>
            </div>
          </div>

          <ShippingSettings />
          <p className="text-xs text-muted-foreground pl-4">
            Auto-updated when Shipping Rules are saved.
          </p>

          <ChargeableShippingSettings />

          <ReviewSettings />
          <p className="text-xs text-muted-foreground pl-4">
            Configure product review settings for your storefront.
          </p>
        </div>
      </PageContainer>
    </StorefrontSettingsGuard>
  )
}
